
<div class="col-12 mt-2">
  <div class="col-12 flex border border-info rounded " #topDiv>
    <div class="col-6">
      <button pButton icon="fa fa-refresh" label="Refresh" class="p-2 border-round buttonsRound noHover shadow"
      (click)="getDataForInvoicingItem()"></button>
    </div>
    <div class="col-6 flex justify-content-end">
      <button pButton label="Export Billable Invoiceitems" icon="fa fa-download" class="p-2 border-round buttonsRound noHover float-right shadow"
      [disabled]="!(setRowdataforExport && setRowdataforExport.length != 0)" (click)="exportToExcel()"></button>
    </div>
   </div>
  <div class="col-12"   [style.height.px]="divHeight">
    <p-table #dt [value]="invoicingValues" [columns]="scrollableCols"  selectionMode="multiple" [scrollHeight]="scrollHeight" [scrollable]="true">
      <ng-template pTemplate="caption">
        <div class="flex justify-content-end">
            <em class="fa fa-search" ></em>
            <input class="p-1" type="text" pInputText size="50" placeholder="Global Filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr >
           <th scope="col" class="text-center colWidth">Sender Short Name</th>
        <th scope="col"   class="text-center colWidth">#Samples Received</th>
        <th scope="col"  class="text-center colWidth">#Drop outs</th>
        <th scope="col" class="text-center colWidth">#Billable Samples</th>
        <th scope="col"  class="text-center colWidth">Unit Price [EUR]</th>
        <th scope="col"class="text-center colWidth">Total Price [EUR]</th>
        <th scope="col"  class="text-center colWidth">
          <input type="checkbox" [(ngModel)]="isSelected" (change)="getcheckBoxDataforAllRow($event)"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" >
          <ng-container *ngFor="let col of columns">
            <td  *ngIf="col.field=='senderShortName'" class="text-center rowtableWidth">
              <a href="javascript:void(0);" (click)="getDialogBox(rowData)"><u>{{rowData[col.field]}}</u></a>
            </td>
            <td  *ngIf="col.field == 'samplesReceived'" class="text-center rowtableWidth">
              {{ rowData[col.field]}}
            </td>
            <td  *ngIf="col.field == 'dropOutsSamples'" class="text-center rowtableWidth">
              {{ rowData[col.field]}}
            </td>
            <td  *ngIf="col.field == 'billableSamples'" class="text-center rowtableWidth">
              {{ rowData[col.field]}}
            </td>
            <td  *ngIf="col.field == 'unitPrice'" class="text-center rowtableWidth">
              <input type="text"   [ngModel]="rowData[col.field]"  (ngModelChange)="getchecked(rowData,$event)" (focusout)="unitPriceFocusOutEvent(rowData,$event)" placeholder="Enter Unit Price"/>
            </td>
            <td  *ngIf="col.field == 'totalPrice'" class="text-center rowtableWidth">
              {{ getValuesForTotalPrice(col.field, rowData) | number: '1.2-2': 'en' }}
            </td>
            <td  *ngIf="col.field == 'checkbox'" class="text-center">
               <input type="checkbox"   [(ngModel)]="rowData[col.field]"   [disabled]="!rowData['unitPrice'] || rowData['unitPrice']==''"   (change)="getcheckBoxData(rowData,$event.target.checked)"/>
            </td>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr >
          <td [attr.colspan]="7" class="text-center">
            No records found
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div class="col-5 pl-0 mt-3" *ngIf="listOfFile && listOfFile.length>0" style="width: 72%;">
      <div class="col-12 flex"><h5><u>BillableInvoiceItems</u></h5></div>
      <div class="col-12 flex"  *ngFor="let file of listOfFile">
          <a href="javascript:void(0);" (click)="downloadFile(file)"><u>{{file.fileName}}</u></a>
      </div>
    </div>
  </div>
</div>
<p-dialog header="{{ senderShortNameForDisplay }}"[(visible)]="batchIdPopup" [focusOnShow]="false" showEffect="fade" [modal]="true">
    <p-table  [value]="getdetailsOfSenderPopup" [columns]="scrollableColsforPopup"  selectionMode="multiple" [scrollHeight]="scrollHeight" [scrollable]="true">
      <ng-template pTemplate="header" let-columns>
        <tr >
          <th scope="col" *ngFor="let col of columns" class="text-center" style="width: 10rem;" >
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" >
          <ng-container *ngFor="let col of columns">
            <td style="overflow:visible;word-break: break-word;" class="text-center">
              {{ getValuesForPopup(col.field, rowData)}}
            </td>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr >
          <td [attr.colspan]="8" class="text-center">
            No records found
          </td>
        </tr>
      </ng-template>
      </p-table>
      <p-paginator #pp [rows]="10" (onPageChange)="paginate($event)" totalRecords="{{totalRecords}}" pageLinks="3" ></p-paginator>
</p-dialog>

<p-blockUI [blocked]="blocked">
  <div>
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
